import script from "./RoutePoiList.vue?vue&type=script&setup=true&lang=js"
export * from "./RoutePoiList.vue?vue&type=script&setup=true&lang=js"

import "./RoutePoiList.vue?vue&type=style&index=0&id=44ae0a98&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44ae0a98"]])

export default __exports__